// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import classNames from 'classnames';
import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const ShieldImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path className={classes.st5} d="M1673.42 542.11 960.51 953.7 251.36 544.28l712.91-411.6z" />
    <text transform="matrix(.9146 -.5281 .866 .5 781.967 665.475)">
      <tspan x="0" y="0" className={classNames(classes.st0, classes.st7, classes.st8)}>
        IBM{' '}
      </tspan>
      <tspan x="145.72" y="0" className={classNames(classes.st0, classes.st8, classes.st9)}>
        Quantum
      </tspan>
    </text>
    <path className={classes.st10} d="M960.51 953.7v16.76L251.36 561.04v-16.76z" />
    <path className={classes.st5} d="M960.51 953.7v16.76l712.91-411.59v-16.76z" />
    <text
      transform="matrix(-.82 -.4734 .866 -.5 1567.395 552.79)"
      className={classNames(classes.st0, classes.st7, classes.st11)}
    >
      Eagle
    </text>
  </svg>
);

export default ShieldImage;
